import { render, staticRenderFns } from "./IdentityEdit.vue?vue&type=template&id=10df32f9&scoped=true"
import script from "./IdentityEdit.vue?vue&type=script&lang=js"
export * from "./IdentityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df32f9",
  null
  
)

export default component.exports